import { render, staticRenderFns } from "./NotifyBadge.vue?vue&type=template&id=2fd5b5eb&"
import script from "./NotifyBadge.vue?vue&type=script&lang=ts&"
export * from "./NotifyBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports